import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { classnames as i } from "../utils/classnames.js";
import '../../assets/NetworkIndicator.css';function c({ online: n, text: r }) {
  return /* @__PURE__ */ t("div", { className: "networkIndicator", children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: i(
          ["networkIndicator-point"],
          ["networkIndicator-point--online", n],
          ["networkIndicator-point--offline", !n]
        )
      }
    ),
    /* @__PURE__ */ o("span", { children: r })
  ] });
}
export {
  c as NetworkIndicator
};
//# sourceMappingURL=NetworkIndicator.js.map
